
import {map, takeUntil,  share } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable, Subject, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
// import { environment } from '../../../environments/environment';
import { APIURLS, environment } from '../../../environments/environment';
import { PageSettingsService } from '../../common/services/page-settings.service';
declare let $: any;
declare let html2canvas: any;
declare global {
    interface Navigator {
        msSaveBlob?: (blob: any, defaultName?: string) => boolean
    }
}
@Injectable({
    providedIn:'root'
})
export class CommonService {
    private ngUnsubscribe: Subject<void> = new Subject<void>();
    checkPageContent: any;
    termPopularityObservable;
    data: Object = {};
    estimateCountData: Object = {};
    wordCloudcache$ = {};
    clusterDataObservable;
    collocateDataObservable: any = {};
    histogramObservable;
    wordCloudObservable;
    printChart = new Subject<any>();
    printFoamTree = new Subject<any>();
    disablePrintDownload = new Subject<any>();
    collocatesCache$: any = {};
    termFreqDataObservable;
    concordanceDataObservable: any = {};
    wordcloudEstimateCountObservable: Observable<any>;
    // distributionEstimateCountObservable: Observable<any>;
    collocateEstimateCountObservable: Observable<any>;
    concordanceEstimateCountObservable: Observable<any>;
    newFilterParams: any;
    constructor(
        private httpClient: HttpClient,
    ) {
        PageSettingsService.pageSettingsObservable.pipe(takeUntil(this.ngUnsubscribe)).subscribe(data => {
            if (data) {
              this.checkPageContent = data;
            }
          });
     }
    /**
     * @description : fetch cluster data for foam tree and circle charts
     * @param params :Adv.params
     */
    getClusterData(params): Observable<any> {
        if (this.data[JSON.stringify(params)]) {
            return of(this.data[JSON.stringify(params)]);
        } else if (this.clusterDataObservable) {
            return this.clusterDataObservable;
        } else {
            this.clusterDataObservable =
                this.httpClient.post<any>(`${environment.APIUrl}${APIURLS.getFoamClusters}`, params, { observe: 'response' }).pipe(
                    map(response => {
                        this.clusterDataObservable = null;
                        if (response.status === 400) {
                            return 'Request failed.';
                        } else if (response.status === 200) {
                            this.data[JSON.stringify(params)] = response.body;
                            return this.data[JSON.stringify(params)];
                        }
                    })).pipe(share());
            return this.clusterDataObservable;
        }
    }
    /**
     * @description: get search results for given term and limiters from cluster.
     * @param params : Advanced params
     * @returns :post request of adv.search
     */
    getClusterSearchResult(params): Observable<any> {
        return this.httpClient.post<any>(`${environment.APIUrl}${APIURLS['advancedSearch']}`, params);
    }
    /**
     * @description : Initialized, while revamping analysis hub
     * @param imgDataUrl : Downloading file path
     * @param imageName : Downlaoding file name should show as particular file name
     */
    downloadImage(imgDataUrl, imageName?): void {
        imageName = imageName || 'image.png';
        const res = new Blob([this.dataURItoBlob(imgDataUrl)], { type: 'image/png' });
        if (navigator.userAgent.toString().indexOf('.NET') > 0) { // for IE browser
            window.navigator.msSaveBlob(res, imageName);
            // iframe.style.display = 'none';
        } else if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {  // for IPAD
            const fileURL = URL.createObjectURL(res);
            window.location.href = fileURL;
        } else {
            const fileURL = window.URL.createObjectURL(res);
            const a = document.createElement('a');
            a.href = fileURL;
            a.download = imageName;
            a.style.display = 'none';
            document.body.appendChild(a);
            a.click();
            setTimeout(() => {
                document.body.removeChild(a);
                window.URL.revokeObjectURL(fileURL);
            }, 2000);
        }
    }
    /**
     * @description : URL converted into raw data
     * @param dataURI : base64 URL
     * @returns : return blob image
     */
    private dataURItoBlob(dataURI) {
        // convert base64 to raw binary data held in a string
        // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
        const byteString = atob(dataURI.split(',')[1]);

        // separate out the mime component
        const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

        // write the bytes of the string to an ArrayBuffer
        const ab = new ArrayBuffer(byteString.length);

        // create a view into the buffer
        const ia = new Uint8Array(ab);

        // set the bytes of the buffer to the correct values
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }

        // write the ArrayBuffer to a blob, and you're done
        const blob = new Blob([ab], { type: mimeString });
        return blob;

    }
    /**
     * @description :print frequency charts
     * @param data : Boolean value
     */
    currentStatusforPrint(data): void {
        this.printChart.next(data);
    }
    /**
     * @description :print foamtree/circle chart
     * @param data : option for print/download
     */
    printTheFoamTree(data): void {
        this.printFoamTree.next(data);
    }

    /**
   * @description : fetch data for Frequency distribution either local json/ service
   * @param params :Adv.params
   * @param archive :archive If the archive is available then we should load data from local json
   */
    // getHistogramResult(params, archive?): Observable<any> {
    //     if (archive) {
    //         const getArchiveJsonDataUrl = `${APIURLS.getFrequencyDistributionInit}${archive.toLowerCase()}.json`;
    //         if (this.data[getArchiveJsonDataUrl]) {
    //             return of(this.data[getArchiveJsonDataUrl]);
    //         }
    //         return this.httpClient.get<any>(getArchiveJsonDataUrl, { observe: 'response' }).pipe(
    //             map(response => {
    //                 if (response.status === 200) {
    //                     this.data[getArchiveJsonDataUrl] = response.body;
    //                     return this.data[getArchiveJsonDataUrl];
    //                 }
    //             })).pipe(share());
    //     } else {
    //         if (this.data[JSON.stringify(params)]) {
    //             return of(this.data[JSON.stringify(params)]);
    //         // } else if (this.histogramObservable) {
    //         //     return this.histogramObservable;
    //         } else {
    //             this.histogramObservable = this.httpClient.post<any>(`${environment.APIUrl}${APIURLS['frequencyDistribution']}`,
    //                 params, { observe: 'response' }).pipe(
    //                 map(response => {
    //                     this.histogramObservable = null;
    //                     if (response.status === 400) {
    //                         return 'Request failed.';
    //                     } else if (response.status === 200) {
    //                         this.data[JSON.stringify(params)] = response.body;
    //                         return this.data[JSON.stringify(params)];
    //                     }
    //                 })).pipe(share());
    //         }
    //         return this.histogramObservable;
    //     }
    // }
    /**
     * @description : Print chart
     * @param fileName : Display file name in print page
     */
    printTermFrequencyChart(fileName, limitFilterValue, termGroupsData?, chartTitle?) {
        this.processLimiterForPrint(limitFilterValue, (limiterHtml) => {
            const newWin = window.frames['printf'];
            newWin.document.write('');
            let htmlContent = '';
            htmlContent = $('.analysisHub-tabs').html();
            const termsList = document.querySelector('.addmoreterms-list');
            const noOfDocumentLabel = $('span.chart-label.no-print').text();
            let termPopularityStyle = '';
            if (fileName === 'Term Popularity') {
                termPopularityStyle = 'termPopularitys';
            }
            let term_title = '';
            if (termsList) {
                term_title = 'Terms';
            }
            let newData = '';
            if (fileName === 'Term Groups') {
                newData = termGroupsData;
            } else {
                newData = document.getElementsByTagName('canvas')[0].toDataURL();
            }
            chartTitle = chartTitle ? chartTitle : '';
            // tslint:disable-next-line: max-line-length
            newWin.document.write(`<html><head><style>@media print {body {margin: 0 !important;}#chartContainer{margin-left:22px !important;}}body{font-family: 'Open Sans', sans-serif !important;}.limiter-badge{background: #dadada;border-radius: 5px;color: #000;padding: 4px 7px 4px 15px}.limit-content{margin:5px}.limit-data{font-size: 13px;}.limit-title{font-size: 12px;font-weight: 500;font-family: 'Open Sans', sans-serif !important}@import url('https://fonts.googleapis.com/css?family=Open+Sans:400,600,600i,700,700i,800,800i');@import url('https://fonts.googleapis.com/css?family=Source+Serif+Pro:400,600,700');body{font-family:'Open Sans',sans-serif !important;-webkit-print-color-adjust:exact !important}.term-frequency{display:block;margin:20px}#chartContainer{position:relative;max-width: 100%;width:auto;height:auto;margin-top:10px;margin-left:10px;}.search-resultlbl{color:#414246;font-size:11px;font-weight:300;display:block;float:left;margin-right:3px;line-height:16px;width:100%;padding-bottom:2px;text-transform:uppercase;margin-bottom:0}.chartAreaWrapper{height:10px}.badge{margin-right:5px;font-weight:600;border-radius:3px;background-color:#dedede;color:#000}.search-resultcount{display:inline-block;vertical-align:top;padding-top:5px;float:right}.result-tag li{list-style:none;float:left;margin-right:0;min-height:40px;padding:0;max-width:150px}.select-qry{max-width:77px;display:inline-block;text-overflow:ellipsis;overflow:hidden;padding:5px 4px 5px 0;text-align:left;cursor:pointer;height:13px}.searchList li{list-style:none;min-width:120px;border-radius:0;text-transform:capitalize;text-align:left}.badge{padding:1px 7px;margin-right:5px;font-weight:600;border-radius:3px;background-color:#dedede;color:#000;cursor:pointer;min-width:120px;display:inline-block;text-align:left !important}ul{padding-left:0}.searchQry{margin-top:4px;font-size:14px;padding:5px}.chart-query-container-title{width:100%;font-family:'Source Serif Pro',serif !important}.display-badge{display:inline-block;overflow:hidden;min-height:13px;padding-top:3px}.search_qry_term{list-style-type:none}.operator{padding:0 10px 0 0;color:#414246;font-weight:600}.limitedBy{float:left;font-style:italic;padding-right:13px;width:100px;padding-right:19px;margin-top:18px}.searchBy{float:left;font-style:italic;padding-right:13px;padding-right:19px;width:100px;margin-top:18px}.badge.margin-left5{margin:0px !important}.search-resultlbl{color:#414246;font-size:11px;font-weight:300;display:block;float:left;margin-right:3px;line-height:16px;width:100%;padding-bottom:2px;text-transform:uppercase;margin-bottom:0}.searchQry.search_qry_term{display:inline-flex}.search_qry_term li{min-width:190px}.archivesSelectList{padding-top:15px;padding-right:0px;width:165px}.mr-43{margin-right:43px}.no-border-radious{border-radius:0px}.chart-label{position:absolute;transform:rotate(-90deg);left:-56px;margin-top:10%;color: #636363;}.pop-label{left:-40px !important}.mr-5{margin-right:5px}.searchList>li>span.badge{padding:6px 11px;line-height:1.3}.slider-control{padding:0px 27px 8px 30px}.badge.margin-left5{text-align:left;cursor:default !important;min-width:190px !important;height:26px}.select-qry-pub{max-width:200px;display:inline-block;text-overflow:ellipsis;overflow:hidden;text-align:left}.select-qry-pub-date{display:inline-block;text-overflow:ellipsis;overflow:hidden;text-align:left;white-space:nowrap}.m-r-6{margin-right:0px}.inline-label{display:block}.operator-visible{width:180px;display:inline-block}.pubdate-p{margin:2px}.search-reslbl{color:#000;font-size:14px;font-weight:700;text-transform:capitalize;position:relative;display:block;float:left;line-height:16px;margin-bottom:11px;max-width:180px}.search_qry_term .search-reslbl{text-transform:none;min-width:149px}.mrgn-l0{margin-left:0 !important;margin-right:5px}.simpleSearch{max-width:115px;display:inline-block;text-overflow:ellipsis;overflow:hidden;text-align:left;cursor:pointer;white-space:nowrap}.badge-operator-search-term{margin-right:15px}.search_qry_term .search-reslbl-single{text-transform:none;min-width:127px}.m-l-4{margin-left:4px}.searchKeyDiv{max-width:none !important}.searchKeyDocs{margin-right:6px;display:inline-block;float:left}.result-tag li.simpleSearchTerm{max-width:188px}.multiselect-dropdown-item .btn{padding:11px 12px !important}.no-padding.add{width:80%;display:inline-block}.searchqryAdv{max-width:100px;display:inline-block;text-overflow:ellipsis;overflow:hidden;text-align:left;height:19px}.languageDiv{height:16px}.popover_inner_span{cursor:pointer;display:block;text-overflow:ellipsis;overflow:hidden;min-width:auto;white-space:nowrap;float:left !important;max-width:137px}.popoverUl{padding-bottom:0 !important}.popoverUl li{width:100% !important;min-height:auto !important;font-size:13px;max-width:initial !important}ul.popoverUl{list-style-type:none;min-width:135px;display:inline-flex}.popoverUl i.fa.fa-times{margin-top:3px}.query-str{min-height:20px;padding-top:15px;max-width:80px;text-overflow:ellipsis;overflow:hidden}.addmoreterms-list{float:left;width:100%;margin-top:10px}#keywordDiv.search-reslbl.operator-visible .badge{padding:7px 8px !important}.print-hide, .contentlist, .no-print, canvas, .docviewer-tabs ul.nav.nav-tabs{display:none}.resetLink,.groups_frame-loader,h4.chart-query-container-title,.alert.alert-info.h4{display:none}.tab-content{height:0}span.margin-left5 {font-size: 13px;}.rmRadius{border-radius: unset;}.contentWidth{max-width: 100px;display: inline-block;}.termPopularitys{left:-40px !important;}</style></head><body onload="setTimeout(function() { window.print(); }, 500);"><div style="width: 100%;"><h2 style="font-family: 'Source Serif Pro', serif !important;">${fileName}</h2><p style="font-weight:600;margin:0;font-family: 'Source Serif Pro', serif !important;">${term_title}</p>${htmlContent}<p style="font-weight:600;margin:0;font-family: 'Source Serif Pro', serif !important;">Limiters</p>${limiterHtml} ${chartTitle} <span class="chart-label ${termPopularityStyle}"> ${noOfDocumentLabel}</span> <img src="${newData}" id="chartContainer"></div></body></html>`);
            newWin.document.close();
        });
    }


    gettermFrequencyData(params): Observable<any> {
        if (this.data[JSON.stringify(params)]) {
            return of(this.data[JSON.stringify(params)]);
        } else if (this.termFreqDataObservable) {
            return this.termFreqDataObservable;
        } else {
            this.termFreqDataObservable =
                this.httpClient.post<any>(`${environment.APIUrl}${APIURLS.statssearch}`, params, { observe: 'response' }).pipe(
                    map(response => {
                        this.termFreqDataObservable = null;
                        if (response.status === 400) {
                            return 'Request failed.';
                        } else if (response.status === 200) {
                            this.data[JSON.stringify(params)] = response.body;
                            return this.data[JSON.stringify(params)];
                        }
                    })).pipe(share());
            return this.termFreqDataObservable;
        }
    }
    gettermPopularityData(params): Observable<any> {
        if (this.data[JSON.stringify(params)]) {
            return of(this.data[JSON.stringify(params)]);
        } else if (this.termPopularityObservable) {
            return this.termPopularityObservable;
        } else {
            this.termPopularityObservable =
                this.httpClient.post<any>(`${environment.APIUrl}${APIURLS.termPopularity}`, params, { observe: 'response' }).pipe(
                    map(response => {
                        this.termPopularityObservable = null;
                        if (response.status === 400) {
                            return 'Request failed.';
                        } else if (response.status === 200) {
                            this.data[JSON.stringify(params)] = response.body;
                            return this.data[JSON.stringify(params)];
                        }
                    })).pipe(share());
            return this.termPopularityObservable;
        }
    }
    getAnalysisDetailsForAdvancedSearch(advancedFilters, searchTerm) {
        if (searchTerm.includes('"')) {
            searchTerm = searchTerm.replace(/\"/g, '');
        }
        const advParam = JSON.parse(JSON.stringify(advancedFilters));
        advParam.terms = [searchTerm];
        advParam.filterParams.forEach(obj => {
            if (obj.fieldName === 'pubStartDate' && obj.fieldValue === 'All') {
                obj.condition = 'All';
                obj.fieldValue = '';
            }
        });
        if (this.data[JSON.stringify(advParam)]) {
            return of(this.data[JSON.stringify(advParam)]);
        } else if (this.collocateDataObservable[`${searchTerm}`]) {
            return this.collocateDataObservable[`${searchTerm}`];
        } else {
            this.collocateDataObservable[`${searchTerm}`] =
                this.httpClient.post<any>(`${environment.APIUrl}${APIURLS.getAnalysis}`, advParam, { observe: 'response' }).pipe(
                    map(response => {
                        this.collocateDataObservable[`${searchTerm}`] = null;
                        if (response.status === 400) {
                            return 'Request failed.';
                        } else if (response.status === 200) {
                            this.data[JSON.stringify(advParam)] = response.body;
                            return this.data[JSON.stringify(advParam)];
                        }
                    })).pipe(share());
            return this.collocateDataObservable[`${searchTerm}`];
        }
    }
    /**
     * @description : get word cloud data from service
     * @param params : advanced filter params
     * @param archive : particular archives
     */
    getWordCloudResult(params, archive?): Observable<any> {
        if (this.data[JSON.stringify(params)]) {
            return of(this.data[JSON.stringify(params)]);
        // } else if (this.wordCloudObservable) {
        //     return this.wordCloudObservable;
        } else {
            if (archive) {
                this.wordCloudObservable =
                    this.httpClient.get<any>(`${APIURLS.getWordCloudArchiveInit}${archive.toUpperCase()}.json`, { observe: 'response' }).pipe(
                        map(response => {
                            this.wordCloudObservable = null;
                            if (response.status === 400) {
                                return 'Request failed.';
                            } else if (response.status === 200) {
                                this.data[JSON.stringify(params)] = response.body;
                                return this.data[JSON.stringify(params)];
                            }
                        })).pipe(share());
            } else {
                this.wordCloudObservable =
                    this.httpClient.post<any>(`${environment.APIUrl}${APIURLS['getWordCloud']}`, params, { observe: 'response' }).pipe(
                        map(response => {
                            this.wordCloudObservable = null;
                            if (response.status === 400) {
                                return 'Request failed.';
                            } else if (response.status === 200) {
                                this.data[JSON.stringify(params)] = response.body;
                                return this.data[JSON.stringify(params)];
                            }
                        })).pipe(share());
            }
            return this.wordCloudObservable;
        }
    }

    /**
     * @description : get concordance data from service
     * @param advanParams :  advanced filter params\
     * @param term: Search term
     */
    getConcordanceResult(advanParams, term): Observable<any> {
        if (this.data[JSON.stringify(advanParams)]) {
            return of(this.data[JSON.stringify(advanParams)]);
        } else if (this.concordanceDataObservable[term]) {
            return this.concordanceDataObservable[term];
        } else {
            this.concordanceDataObservable[term] =
                this.httpClient.post<any>(`${environment.APIUrl}${APIURLS.getConcordance}`, advanParams, { observe: 'response' }).pipe(
                    map(response => {
                        this.concordanceDataObservable[term] = null;
                        if (response.status === 400) {
                            return 'Request failed.';
                        } else if (response.status === 200) {
                            this.data[JSON.stringify(advanParams)] = response.body;
                            return this.data[JSON.stringify(advanParams)];
                        }
                    })).pipe(share());
            return this.concordanceDataObservable[term];
        }
    }
    /**
     * @description :get search count estimation for word cloud
     * @param form :limiter form data
     */
    getWordCloudEstimatedCount(form): Observable<any> {
        this.newFilterParams = form.filterParams;
        if (this.newFilterParams.length > 0) {
        for(let k =0; k < this.newFilterParams.length; k++) {
            if(this.newFilterParams[k].fieldName === "archive") {
            const getSelectedArchives = localStorage.getItem('wileySelectedArchive');
            const haveRGS = this.newFilterParams[k].fieldValues && this.newFilterParams[k].fieldValues.includes('RGS'); 
            if (haveRGS) {
            const haveRGS1 = getSelectedArchives.includes('RGS1');
            if(haveRGS1) {
                this.newFilterParams[k].fieldValues.push('RGS1');
            }
            const haveRGS2 = getSelectedArchives.includes('RGS2');
            if(haveRGS2) {
                this.newFilterParams[k].fieldValues.push('RGS2');
            }
            this.newFilterParams[k].fieldValues = this.removeSelectedValFromArray('RGS',this.newFilterParams[k].fieldValues);
            }
            const haveRCP = this.newFilterParams[k].fieldValues && this.newFilterParams[k].fieldValues.includes('RCP'); 
            if (haveRCP) {
            const haveRCP1 = getSelectedArchives.includes('RCP1');
            if(haveRCP1) {
                this.newFilterParams[k].fieldValues.push('RCP1');
            }
            const haveRCP2 = getSelectedArchives.includes('RCP2');
            if(haveRCP2) {
                this.newFilterParams[k].fieldValues.push('RCP2');
            }
            this.newFilterParams[k].fieldValues = this.removeSelectedValFromArray('RCP',this.newFilterParams[k].fieldValues);
            }
            }
        }
        if(this.newFilterParams) {
            form.filterParams = this.newFilterParams;
        }
        }

        if (this.estimateCountData[JSON.stringify(form)]) {
            return of(this.estimateCountData[JSON.stringify(form)]);
        } else {
            form['isResultNeeds'] = false;
            this.wordcloudEstimateCountObservable =
                this.httpClient.post<any>(`${environment.APIUrl}${APIURLS.getWordCloud}`, form).pipe(
                    map(response => {
                        // if (response.status === 200) {
                            this.estimateCountData[JSON.stringify(form)] = response;
                            return this.estimateCountData[JSON.stringify(form)];
                        // }
                    })).pipe(share());
            return this.wordcloudEstimateCountObservable;
        }
    }
    removeSelectedValFromArray(val, arr) {
        let value = val;
        arr = arr.filter(item => item !== value)
        return arr;
    }
    /**
    * @description :get search count estimation for distribution
    * @param form :limiter form data
    */
    // getDistributionEstimatedCount(form): Observable<any> {
    //     if (this.estimateCountData[JSON.stringify(form)]) {
    //         return of(this.estimateCountData[JSON.stringify(form)]);
    //     } else {
    //         form['isResultNeeds'] = false;
    //         this.distributionEstimateCountObservable =
    //             this.httpClient.post<any>(`${environment.APIUrl}${APIURLS.frequencyDistribution}`, form).pipe(
    //                 map(response => {
    //                     // if (response.status === 200) {
    //                         this.estimateCountData[JSON.stringify(form)] = response;
    //                         return this.estimateCountData[JSON.stringify(form)];
    //                     // }
    //                 })).pipe(share());
    //         return this.distributionEstimateCountObservable;
    //     }
    // }
    /**
    * @description :get search count estimation for collocation
    * @param form :limiter form data
    */
    getCollocationEstimatedCount(form): Observable<any> {
        const terms = sessionStorage.getItem('sessionFilterInput');
        form['terms'] = terms ? JSON.parse(terms) : [];
        if (this.estimateCountData[JSON.stringify(form)]) {
            return of(this.estimateCountData[JSON.stringify(form)]);
        } else {
            form['isResultNeeds'] = false;
            this.collocateEstimateCountObservable =
                this.httpClient.post<any>(`${environment.APIUrl}${APIURLS.getAnalysis}`, form).pipe(
                    map(response => {
                        // if (response.status === 200) {
                            this.estimateCountData[JSON.stringify(form)] = response;
                            return this.estimateCountData[JSON.stringify(form)];
                        // }
                    })).pipe(share());
            return this.collocateEstimateCountObservable;
        }
    }
    /**
    * @description :get search count estimation for concordance
    * @param form :limiter form data
    */
    getConcordanceEstimatedCount(form): Observable<any> {
        const terms = sessionStorage.getItem('sessionFilterInput');
        form['terms'] = terms ? JSON.parse(terms) : [];
        if (this.estimateCountData[JSON.stringify(form)]) {
            return of(this.estimateCountData[JSON.stringify(form)]);
        } else {
            form['isResultNeeds'] = false;
            this.concordanceEstimateCountObservable =
                this.httpClient.post<any>(`${environment.APIUrl}${APIURLS.getConcordance}`, form).pipe(
                    map(response => {
                            this.estimateCountData[JSON.stringify(form)] = response;
                            return this.estimateCountData[JSON.stringify(form)];
                    })).pipe(share());
            return this.concordanceEstimateCountObservable;
        }
    }
    downloadChartContent(chartUrl, limitFilterValue, fileName, chartTitle, downloadName) {
        this.processLimiterForPrint(limitFilterValue, (limiterHtml) => {
        const newWin = window.frames['printf'];
        newWin.document.write('');
        newWin.document.innerHTML = '';
        let htmlContent = '';
        htmlContent = $('.analysisHub-tabs').html();
        const termsList = document.querySelector('.addmoreterms-list');
        const noOfDocumentLabel = $('span.chart-label.no-print').text();
        let termPopularityStyle = '';
        if (fileName === 'Term popularity') {
            termPopularityStyle = 'margin-left:20px !important;padding: 20px';
        } else if (fileName === "Term Groups") {
            termPopularityStyle = ''
        } else {
            termPopularityStyle = 'padding: 20px'
        }
        let term_title = '';
        if (termsList) {
            term_title = 'Terms';
        }
        let newData = '';
        newData = chartUrl;
        // tslint:disable-next-line: max-line-length
        let htmlData;
        if (fileName === "Term Groups") {
         htmlData = `<html><head><style>body{font-family: 'Open Sans', sans-serif !important; background-color:white  !important;padding:15px 50px 15px 15px;}.limiter-badge{background: #dadada;border-radius: 5px;color: #000;padding: 4px 7px 4px 15px}.limit-content{margin:0px;}.limit-data{font-size: 12px;}.limit-title{font-size: 12px;font-weight: 500;font-family: 'Open Sans', sans-serif !important}@import url('https://fonts.googleapis.com/css?family=Open+Sans:400,600,600i,700,700i,800,800i');@import url('https://fonts.googleapis.com/css?family=Source+Serif+Pro:400,600,700');body{font-family:'Open Sans',sans-serif !important;-webkit-print-color-adjust:exact !important}.term-frequency{display:block;margin:0px}#chartContainer{position:relative;max-width: 100%;width:auto;height:auto;margin-top:10px;margin-left:0px;object-fit: contain;}.search-resultlbl{color:#414246;font-size:11px;font-weight:300;display:block;float:left;line-height:16px;width:100%;padding-bottom:2px;text-transform:uppercase;margin-bottom:0}.chartAreaWrapper{height:10px;}.badge{margin-right:5px;font-weight:600;border-radius:3px;background-color:#dedede;color:#000}.search-resultcount{display:inline-block;vertical-align:top;padding-top:5px;float:right}.result-tag li{list-style:none;float:left;margin-right:0;min-height:40px;padding:0;max-width:150px}.select-qry{max-width:77px;display:inline-block;text-overflow:ellipsis;overflow:hidden;padding:5px 4px 5px 0;text-align:left;cursor:pointer;height:13px}.searchList li{list-style:none;min-width:120px;border-radius:0;text-transform:capitalize;text-align:left}.badge{padding:1px 7px;margin-right:5px;font-weight:600;border-radius:3px;background-color:#dedede;color:#000;cursor:pointer;min-width:120px;display:inline-block;text-align:left !important}ul{padding-left:0}.searchQry{margin-top:4px;font-size:14px;padding:5px}.chart-query-container-title{width:100%;font-family:'Source Serif Pro',serif !important}.display-badge{display:inline-block;overflow:hidden;min-height:13px;padding-top:3px}.search_qry_term{list-style-type:none}.operator{padding:0 10px 0 0;color:#414246;font-weight:600}.limitedBy{float:left;font-style:italic;padding-right:13px;width:100px;padding-right:19px;margin-top:18px}.searchBy{float:left;font-style:italic;padding-right:13px;padding-right:19px;width:100px;margin-top:18px}.badge.margin-left5{margin:0px !important}.search-resultlbl{color:#414246;font-size:11px;font-weight:300;display:block;float:left;margin-right:3px;line-height:16px;width:100%;padding-bottom:2px;text-transform:uppercase;margin-bottom:0}.searchQry.search_qry_term{display:inline-flex}.search_qry_term li{min-width:190px}.archivesSelectList{padding-top:15px;padding-right:0px;width:165px}.mr-43{margin-right:43px}.no-border-radious{border-radius:0px}.chart-label{position:absolute;transform:rotate(-90deg);left:-56px;margin-top:10%;color: #636363;}.pop-label{left:-40px !important}.mr-5{margin-right:5px}.searchList>li>span.badge{padding:6px 11px;line-height:1.3}.slider-control{padding:0px 27px 8px 30px}.badge.margin-left5{text-align:left;cursor:default !important;min-width:190px !important;height:26px}.select-qry-pub{max-width:200px;display:inline-block;text-overflow:ellipsis;overflow:hidden;text-align:left}.select-qry-pub-date{display:inline-block;text-overflow:ellipsis;overflow:hidden;text-align:left;white-space:nowrap}.m-r-6{margin-right:0px}.inline-label{display:block}.operator-visible{width:180px;display:inline-block}.pubdate-p{margin:2px}.search-reslbl{color:#000;font-size:14px;font-weight:700;text-transform:capitalize;position:relative;display:block;float:left;line-height:16px;margin-bottom:11px;max-width:180px}.search_qry_term .search-reslbl{text-transform:none;min-width:149px}.mrgn-l0{margin-left:0 !important;margin-right:5px}.simpleSearch{max-width:115px;display:inline-block;text-overflow:ellipsis;overflow:hidden;text-align:left;cursor:pointer;white-space:nowrap}.badge-operator-search-term{margin-right:15px}.search_qry_term .search-reslbl-single{text-transform:none;min-width:127px}.m-l-4{margin-left:4px}.searchKeyDiv{max-width:none !important}.searchKeyDocs{margin-right:6px;display:inline-block;float:left}.result-tag li.simpleSearchTerm{max-width:188px}.multiselect-dropdown-item .btn{padding:11px 12px !important}.no-padding.add{width:80%;display:inline-block}.searchqryAdv{max-width:100px;display:inline-block;text-overflow:ellipsis;overflow:hidden;text-align:left;height:19px}.languageDiv{height:16px}.popover_inner_span{cursor:pointer;display:block;text-overflow:ellipsis;overflow:hidden;min-width:auto;white-space:nowrap;float:left !important;max-width:137px}.popoverUl{padding-bottom:0 !important}.popoverUl li{width:100% !important;min-height:auto !important;font-size:13px;max-width:initial !important}ul.popoverUl{list-style-type:none;min-width:135px;display:inline-flex}.popoverUl i.fa.fa-times{margin-top:3px}.query-str{min-height:20px;padding-top:15px;max-width:80px;text-overflow:ellipsis;overflow:hidden}.addmoreterms-list{float:left;width:100%;margin-top:10px}#keywordDiv.search-reslbl.operator-visible .badge{padding:7px 8px !important}.print-hide, .contentlist, .no-print, canvas, .docviewer-tabs ul.nav.nav-tabs{display:none}.resetLink,.groups_frame-loader,h4.chart-query-container-title,.alert.alert-info.h4{display:none}.tab-content{height:0}</style></head><body onload="setTimeout(function() { window.print(); }, 500);"><div style="width: 100%;"><h2 style="font-family: 'Source Serif Pro', serif !important;text-transform: capitalize;">${fileName}</h2><p style="font-weight:600;margin:0;font-family: 'Source Serif Pro', serif !important;">${term_title}</p>${htmlContent} <p style="font-weight:600;margin:0;font-family: 'Source Serif Pro', serif !important;">Limiters</p> ${limiterHtml} <br> ${chartTitle}<br> <span class="chart-label" style="${termPopularityStyle}"> ${noOfDocumentLabel}</span>  <img src="${newData}" id="chartContainer"><br></div></body></html>`;
        } else {
         htmlData = `<html><head><style>body{font-family: 'Open Sans', sans-serif !important; background-color:white  !important;padding:20px 20px 20px 30px;}.limiter-badge{background: #dadada;border-radius: 5px;color: #000;padding: 4px 7px 4px 15px}.limit-content{margin:5px}.limit-data{font-size: 13px;}.limit-title{font-size: 12px;font-weight: 500;font-family: 'Open Sans', sans-serif !important}@import url('https://fonts.googleapis.com/css?family=Open+Sans:400,600,600i,700,700i,800,800i');@import url('https://fonts.googleapis.com/css?family=Source+Serif+Pro:400,600,700');body{font-family:'Open Sans',sans-serif !important;-webkit-print-color-adjust:exact !important}.term-frequency{display:block;margin:20px}#chartContainer{position:relative;max-width: 100%;width:auto;height:auto;margin-top:10px;margin-left:0px;object-fit: contain;}.search-resultlbl{color:#414246;font-size:11px;font-weight:300;display:block;float:left;margin-right:3px;line-height:16px;width:100%;padding-bottom:2px;text-transform:uppercase;margin-bottom:0}.chartAreaWrapper{height:10px}.badge{margin-right:5px;font-weight:600;border-radius:3px;background-color:#dedede;color:#000}.search-resultcount{display:inline-block;vertical-align:top;padding-top:5px;float:right}.result-tag li{list-style:none;float:left;margin-right:0;min-height:40px;padding:0;max-width:150px}.select-qry{max-width:77px;display:inline-block;text-overflow:ellipsis;overflow:hidden;padding:5px 4px 5px 0;text-align:left;cursor:pointer;height:13px}.searchList li{list-style:none;min-width:120px;border-radius:0;text-transform:capitalize;text-align:left}.badge{padding:1px 7px;margin-right:5px;font-weight:600;border-radius:3px;background-color:#dedede;color:#000;cursor:pointer;min-width:120px;display:inline-block;text-align:left !important}ul{padding-left:0}.searchQry{margin-top:4px;font-size:14px;padding:5px}.chart-query-container-title{width:100%;font-family:'Source Serif Pro',serif !important}.display-badge{display:inline-block;overflow:hidden;min-height:13px;padding-top:3px}.search_qry_term{list-style-type:none}.operator{padding:0 10px 0 0;color:#414246;font-weight:600}.limitedBy{float:left;font-style:italic;padding-right:13px;width:100px;padding-right:19px;margin-top:18px}.searchBy{float:left;font-style:italic;padding-right:13px;padding-right:19px;width:100px;margin-top:18px}.badge.margin-left5{margin:0px !important}.search-resultlbl{color:#414246;font-size:11px;font-weight:300;display:block;float:left;margin-right:3px;line-height:16px;width:100%;padding-bottom:2px;text-transform:uppercase;margin-bottom:0}.searchQry.search_qry_term{display:inline-flex}.search_qry_term li{min-width:190px}.archivesSelectList{padding-top:15px;padding-right:0px;width:165px}.mr-43{margin-right:43px}.no-border-radious{border-radius:0px}.chart-label{position:absolute;transform:rotate(-90deg);left:-56px;margin-top:10%;color: #636363;}.pop-label{left:-40px !important}.mr-5{margin-right:5px}.searchList>li>span.badge{padding:6px 11px;line-height:1.3}.slider-control{padding:0px 27px 8px 30px}.badge.margin-left5{text-align:left;cursor:default !important;min-width:190px !important;height:26px}.select-qry-pub{max-width:200px;display:inline-block;text-overflow:ellipsis;overflow:hidden;text-align:left}.select-qry-pub-date{display:inline-block;text-overflow:ellipsis;overflow:hidden;text-align:left;white-space:nowrap}.m-r-6{margin-right:0px}.inline-label{display:block}.operator-visible{width:180px;display:inline-block}.pubdate-p{margin:2px}.search-reslbl{color:#000;font-size:14px;font-weight:700;text-transform:capitalize;position:relative;display:block;float:left;line-height:16px;margin-bottom:11px;max-width:180px}.search_qry_term .search-reslbl{text-transform:none;min-width:149px}.mrgn-l0{margin-left:0 !important;margin-right:5px}.simpleSearch{max-width:115px;display:inline-block;text-overflow:ellipsis;overflow:hidden;text-align:left;cursor:pointer;white-space:nowrap}.badge-operator-search-term{margin-right:15px}.search_qry_term .search-reslbl-single{text-transform:none;min-width:127px}.m-l-4{margin-left:4px}.searchKeyDiv{max-width:none !important}.searchKeyDocs{margin-right:6px;display:inline-block;float:left}.result-tag li.simpleSearchTerm{max-width:188px}.multiselect-dropdown-item .btn{padding:11px 12px !important}.no-padding.add{width:80%;display:inline-block}.searchqryAdv{max-width:100px;display:inline-block;text-overflow:ellipsis;overflow:hidden;text-align:left;height:19px}.languageDiv{height:16px}.popover_inner_span{cursor:pointer;display:block;text-overflow:ellipsis;overflow:hidden;min-width:auto;white-space:nowrap;float:left !important;max-width:137px}.popoverUl{padding-bottom:0 !important}.popoverUl li{width:100% !important;min-height:auto !important;font-size:13px;max-width:initial !important}ul.popoverUl{list-style-type:none;min-width:135px;display:inline-flex}.popoverUl i.fa.fa-times{margin-top:3px}.query-str{min-height:20px;padding-top:15px;max-width:80px;text-overflow:ellipsis;overflow:hidden}.addmoreterms-list{float:left;width:100%;margin-top:10px}#keywordDiv.search-reslbl.operator-visible .badge{padding:7px 8px !important}.print-hide, .contentlist, .no-print, canvas, .docviewer-tabs ul.nav.nav-tabs{display:none}.resetLink,.groups_frame-loader,h4.chart-query-container-title,.alert.alert-info.h4{display:none}.tab-content{height:0}</style></head><body onload="setTimeout(function() { window.print(); }, 500);"><div style="width: 100%;"><h2 style="font-family: 'Source Serif Pro', serif !important;text-transform: capitalize;">${fileName}</h2><p style="font-weight:600;margin:0;font-family: 'Source Serif Pro', serif !important;">${term_title}</p>${htmlContent} <p style="font-weight:600;margin:0;font-family: 'Source Serif Pro', serif !important;">Limiters</p> ${limiterHtml} <br> ${chartTitle}<br> <span class="chart-label" style="${termPopularityStyle}"> ${noOfDocumentLabel}</span>  <img src="${newData}" id="chartContainer"><br></div></body></html>`;
        }
       
        const that = this;
        const iframe = document.createElement('iframe');
        iframe.id = 'downloadTermCharts';
        iframe.width = '100%';
        iframe.height = '100%';
        iframe.style.color = "#FFFFFF"
        iframe.style.visibility = 'hidden';
        $('body').append($(iframe));
        setTimeout(function () {
            const iframedoc = iframe.contentDocument || iframe.contentWindow.document;
            $('body', $(iframedoc)).html(htmlData);
            html2canvas(iframedoc.body, {
                onrendered: function (canvas) {
                const chartURL = canvas.toDataURL();
                that.downloadImage(chartURL, downloadName + '.png');
                setTimeout(() => {
                    // document.getElementById('downloadTermCharts').remove();
                    const element = document.getElementById('downloadTermCharts');
                    element.parentNode.removeChild(element);
                }, 10);
                }
            });
        }, 100);
    });
    }
    /**
     * Process and create html for limiter display for print and download
     * @param limitFilterValue : adv.filterparam limiter value
     * @param success : callback
     */
    processLimiterForPrint(limitFilterValue: any, success: Function) {
        // let listData = '';
        // if (limitFilterValue.archive.length > 0) {
        //     let availableArchives = '';
        //     limitFilterValue.archive.forEach(archives => {
        //         this.checkPageContent.wileyArchives.forEach(archiveObj => {
        //             if (archives === archiveObj.shortName) {
        //                 availableArchives += `<span class="margin-left5"><div class="badge rmRadius">
        //                 <div class="contentWidth">${archiveObj.name}</div></div></span>`;
        //             }
        //         });
        //     });
        //     listData = `<li class="historyBatch padding-left-0 archivesList">
        //     <label class="search-resultlbl">ARCHIVES </label>
        //     <label>${availableArchives}</label></li>`;
        // }
        // if (limitFilterValue.contentType.length > 0) {
        //     let contentTypeData = '';
        //     limitFilterValue.contentType.forEach(contentType => {
        //         contentTypeData += `<span class="margin-left5" style="padding: 0 !important;">
        //             <div class="badge rmRadius">
        //                 <div class="contentWidth">${contentType}</div>
        //             </div>
        //         </span>
        //         `;
        //     });
        //     listData += `<li><label class="search-resultlbl">CONTENT TYPES  </label>
        //     <label>${contentTypeData}</label></li>`;
        // }
        // if (limitFilterValue.hasOwnProperty('docSubType')) {
        //     if (limitFilterValue.docSubType.length > 0) {
        //         let contentSubTypeData = '';
        //         limitFilterValue.docSubType.forEach(contentsubType => {
        //             contentSubTypeData += `<span class="margin-left5" style="padding: 0 !important;">
        //                 <div class="badge rmRadius">
        //                     <div class="contentWidth">${contentsubType}</div>
        //                 </div>
        //             </span>
        //             `;
        //         });
        //         listData += `<li><label class="search-resultlbl">CONTENT SUBTYPES </label>
        //         <label>${contentSubTypeData}</label></li>`;
        //     }
        // }
        // if (limitFilterValue.hasOwnProperty('languages')) {
        //     if (limitFilterValue.languages.length > 0) {
        //         let languageData = '';
        //         limitFilterValue.languages.forEach(language => {
        //             languageData += `<span class="margin-left5" style="padding: 0 !important;">
        //                 <div class="badge rmRadius">
        //                     <div class="contentWidth">${language}</div>
        //                 </div>
        //             </span>
        //             `;
        //         });
        //         listData += `<li><label class="search-resultlbl">LANGUAGES </label>
        //         <label>${languageData}</label></li>`;
        //     }
        // }
        // if (limitFilterValue.contentSources.length > 0) {
        //     let contentSourceData = '';
        //     limitFilterValue.contentSources.forEach(source => {
        //         contentSourceData += `<span class="margin-left5" style="padding: 0 !important;">
        //             <div class="badge rmRadius">
        //                 <div class="contentWidth">${source}</div>
        //             </div>
        //         </span>
        //         `;
        //     });
        //     listData += `<li><label class="search-resultlbl">SOURCES</label>
        //     <label>${contentSourceData}</label></li>`;
        // }
        // if (limitFilterValue.contentCollection.length > 0) {
        //     let contentCollectionData = '';
        //     limitFilterValue.contentCollection.forEach(collocation => {
        //         contentCollectionData += `<span class="margin-left5" style="padding: 0 !important;">
        //             <div class="badge rmRadius">
        //                 <div class="contentWidth">${collocation}</div>
        //             </div>
        //         </span>
        //         `;
        //     });
        //     listData += `<li><label class="search-resultlbl">COLLECTIONS</label>
        //     <label>${contentCollectionData}</label></li>`;
        // }
        // if (limitFilterValue.subject.length > 0) {
        //     let subjectData = '';
        //     limitFilterValue.subject.forEach(subject => {
        //         subjectData += `<span class="margin-left5" style="padding: 0 !important;">
        //             <div class="rmRadius">
        //                 <div class="contentWidth">${subject}</div>
        //             </div>
        //         </span>
        //         `;
        //     });
        //     listData += `<li><label class="search-resultlbl">SUBJECT</label>
        //     <label>${subjectData}</label></li>`;
        // }
        // if (limitFilterValue.publishedDateFrom || limitFilterValue.publishedDateIncludesNull || limitFilterValue.publishedDatePrefix) {
        //     if (limitFilterValue.publishedDateFrom) {
        //         let dateData = '';
        //         if (limitFilterValue.publishedDateFrom !== 'All') {
        //             dateData = `<span >${limitFilterValue.publishedDatePrefix}: ${limitFilterValue.publishedDateFrom}</span>`;
        //         }
        //         if (limitFilterValue.publishedDateTo) {
        //             dateData += `<span > AND</span>`;
        //         }
        //         if (limitFilterValue.publishedDateTo.includes('-') && limitFilterValue.publishedDateTo.length > 5 &&
        //         limitFilterValue.publishedDateTo.length > 8) {
        //             dateData += `<span >${limitFilterValue.publishedDateTo}</span>`;
        //         }
        //         if (limitFilterValue.publishedDateTo.length === 5) {
        //             dateData += `<span >${limitFilterValue.publishedDateTo.slice(0, 4)}</span>`;
        //         }
        //         if (limitFilterValue.publishedDateTo.length < 5) {
        //             dateData += `<span > ${limitFilterValue.publishedDateTo}</span>`;
        //         }
        //         if (limitFilterValue.publishedDateTo.length === 8) {
        //             dateData += `<span >${limitFilterValue.publishedDateTo.slice(0, 7)}</span>`;
        //         }
        //         if (limitFilterValue.publishedDateIncludesNull) {
        //             dateData += `<span class="pub_date_operator"> AND</span>
        //             <span class="pub_date space-between">UNDATED</span>`;
        //         }
        //         listData += `<li>
        //             <label class="search-resultlbl">DATE</label>
        //                 <span>
        //                     <label>
        //                         <span class="badge" style="font-size: 11px;">
        //                             <p class="pubdate-p">
        //                             <span class="">
        //                                 ${dateData}
        //                             </span>
        //                             </p>
        //                         </span>
        //                     </label>
        //                 </span>
        //             </li>`;
        //     }
        // }
        // const limiterHtml =  `
        // <ul class="col-sm-12 padding-0 advSearch searchQry" >
        //   <ul class="col-sm-10 padding-0" style="max-width:150px;list-style-type:none;display:flex">
        //     ${listData}
        //   </ul>`;

          let listData = '';
          if (limitFilterValue.archive.length > 0) {
              let availableArchives = '';
              limitFilterValue.archive.forEach(archives => {
                  this.checkPageContent.wileyArchives.forEach(archiveObj => {
                      if (archives === archiveObj.shortName) {
                          availableArchives += `<p class="limiter-badge">${archiveObj.name}</p>`;
                      }
                  });
              });
              listData = `<div class="limit-content">
                            <p class="limit-title">ARCHIVES</p>
                            <div class="limit-data">${availableArchives}</div>
                        </div>`;
          }
          // if (limitFilterValue.illustrationType.length > 0) {
          //     let illusData = '';
          //     limitFilterValue.illustrationType.forEach(illustrationType => {
          //         illusData += `<span class="margin-left5" style="padding: 0 !important;">
          //             <div class="badge select-qry pull-left" style="padding: 6px">.
          //                 <div class="searchqryAdv pull-left">${illustrationType}</div>
          //             </div>
          //         </span>
          //         `;
          //     });
          //     listData += `<li><label class="search-resultlbl">CONTENT TYPES </label>
          //     <label>${illusData}</label></li>`;
          // }
          if (limitFilterValue.contentType.length > 0) {
              let contentTypeData = '';
              limitFilterValue.contentType.forEach(contentType => {
                  contentTypeData += `<p class="limiter-badge">${contentType}</p>`;
              });
              listData += `<div class="limit-content">
                            <p class="limit-title">CONTENT TYPES</p>
                            <div class="limit-data">${contentTypeData}</div>
                        </div>`;
          }
          if (limitFilterValue.hasOwnProperty('docSubType')) {
            if (limitFilterValue.docSubType.length > 0) {
                let contentSubTypeData = '';
                limitFilterValue.docSubType.forEach(contentsubType => {
                    contentSubTypeData += `<p class="limiter-badge">${contentsubType}</p>`;
                });
                listData += `<div class="limit-content">
                                <p class="limit-title">CONTENT SUBTYPES</p>
                                <div class="limit-data">${contentSubTypeData}</div>
                            </div>`;
            }
          }
          if (limitFilterValue.hasOwnProperty('languages')) {
            if (limitFilterValue.languages.length > 0) {
                let languageData = '';
                limitFilterValue.languages.forEach(language => {
                    languageData += `<p class="limiter-badge">${language}</p>`;
                });
                listData += `<div class="limit-content">
                            <p class="limit-title">LANGUAGES</p>
                            <div class="limit-data">${languageData}</div>
                        </div>`;
            }
           }
          if (limitFilterValue.contentSources.length > 0) {
              let contentSourceData = '';
              limitFilterValue.contentSources.forEach(source => {
                  contentSourceData += `<p class="limiter-badge">${source}</p>`;
              });
              listData += `<div class="limit-content">
                            <p class="limit-title">SOURCES</p>
                            <div class="limit-data">${contentSourceData}</div>
                        </div>`;
          }
          if (limitFilterValue.contentCollection.length > 0) {
              let contentCollectionData = '';
              limitFilterValue.contentCollection.forEach(collocation => {
                  contentCollectionData += `<p class="limiter-badge">${collocation}</p>`;
              });
              listData += `<div class="limit-content">
                            <p class="limit-title">COLLECTIONS</p>
                          <div class="limit-data">${contentCollectionData}</div>
                        </div>`;
          }
          if (limitFilterValue.subject.length > 0) {
              let subjectData = '';
              limitFilterValue.subject.forEach(subject => {
                  subjectData += `<p class="limiter-badge">${subject}</p>`;
              });
              listData += `<div class="limit-content">
                            <p class="limit-title">SUBJECT</p>
                            <div class="limit-data">${subjectData}</div>
                        </div>`;
          }
          if (limitFilterValue.publishedDateFrom || limitFilterValue.publishedDateIncludesNull || limitFilterValue.publishedDatePrefix) {
              if (limitFilterValue.publishedDateFrom) {
                  let dateData = '';
                  if (limitFilterValue.publishedDateFrom !== 'All') {
                      dateData = `<span >${limitFilterValue.publishedDatePrefix}: ${limitFilterValue.publishedDateFrom}</span>`;
                  }
                  if (limitFilterValue.publishedDateTo) {
                      dateData += `<span > AND </span>`;
                  }
                  if (limitFilterValue.publishedDateTo.includes('-') && limitFilterValue.publishedDateTo.length > 5 &&
                  limitFilterValue.publishedDateTo.length > 8) {
                      dateData += `<span >${limitFilterValue.publishedDateTo}</span>`;
                  }
                  if (limitFilterValue.publishedDateTo.length === 5) {
                      dateData += `<span >${limitFilterValue.publishedDateTo.slice(0, 4)}</span>`;
                  }
                  if (limitFilterValue.publishedDateTo.length < 5) {
                      dateData += `<span > ${limitFilterValue.publishedDateTo}</span>`;
                  }
                  if (limitFilterValue.publishedDateTo.length === 8) {
                      dateData += `<span >${limitFilterValue.publishedDateTo.slice(0, 7)}</span>`;
                  }
                  if (limitFilterValue.publishedDateIncludesNull) {
                      dateData += `<span class="pub_date_operator"> AND</span>
                      <span class="pub_date space-between">UNDATED</span>`;
                  }
                  listData += `<div class="limit-content"><p class="limit-title">DATE</p>
                               <div class="limit-data"><p class="limiter-badge">${dateData}</p></div></div>`;
              }
          }
          const limiterHtml =  `<div style="display:flex;flex-wrap: wrap;flex-direction: row;">${listData}</div>`;
        success(limiterHtml);
    }
    setDisablePrintDownload(data) {
        this.disablePrintDownload.next(data);
    }
}
